import React, { useContext, useEffect, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend,
  Brush, // Import Brush for zoom functionality
} from "recharts";
// import { InverterDetail2, MonthlySumApi } from "../../../../../../api/Api";
import { Refresh } from "@mui/icons-material"; // Import icons
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
import { AuthenticationContext } from "../../../../../../../context/AuthenticationContext";
import { MonthlySumPlant1Api } from "../../../../../../../api/Api";

const MonthlySumPlant1Curve= ({SUB_PLANT}) => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);

  const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const getSixMonthsAgo = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 5);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const [startDate, setStartDate] = useState(getSixMonthsAgo());
  const [endDate, setEndDate] = useState(getCurrentMonth());
  const [logData, setLogData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const credentials = {
    LOGIN_ID: sessionStorage.getItem("LoginID") || "",
    PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
    LCODE: sessionStorage.getItem("LCODE") || "",
    MT1: startDate,
    MT2: endDate,
    TYP: "A",
    WEB_KEY: "WEBXYZ321",
    FID: "216HT001",
    SUB_PLANT:SUB_PLANT
  };

  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await MonthlySumPlant1Api(credentials);
      if (res?.MONTH_SUM && Array.isArray(res.MONTH_SUM)) {
        setLogData(res.MONTH_SUM);
        const transformed = res.MONTH_SUM.map((item) => ({
          MONTH: item.MONTH,
          Plant_Total_KWH_Cumulative: parseFloat(item.Plant_Total_KWH_Cumulative) || 0,
          MONTH_Total_KWH: parseFloat(item.MONTH_Total_KWH) || 0,
          // EXPECTED_KWH: parseFloat(item.EXPECTED_KWH) || 0,
          // MONTH_PR: parseFloat(item.MONTH_PR) || 0,
        }));
        setChartData(transformed);
      } else {
        setLogData([]);
        // console.error("Invalid response format");
      }
    } catch (err) {
      setError("Failed to fetch data");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, [startDate, endDate]);

  return (
    <div className="row">
      <div className="col-md-12" style={{ height: 480, position: "relative" }}>
      
           {/* Top Section */}
           <div style={containerStyle}>
                <p style={responsiveHeaderStyle}>Monthly Energy Summary Curve</p>
                <div style={responsiveControlsStyle}>
                    <label>
                        {/* From Date: */}
                        <input
                            type="month"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <label>
                        {/* To Date: */}
                        To
                        <input
                            type="month"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <button onClick={fetchLogData} style={buttonStyle}>
                        Show
                    </button>
                   
                </div>
            </div>


        {/* Chart */}
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </div>
        ) : (
          <ResponsiveContainer>
            <ComposedChart data={chartData} margin={{ top: 20, right: 100, left: 60, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="MONTH" />

              {/* Left Y-Axis for Cumulative KWH */}
              <YAxis
                yAxisId="left"
                orientation="left"
                stroke="red"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideLeft",
                  fill: "red",
                  offset: 10,
                }}
              />

              {/* Right Y-Axis for Bar Graphs */}
              <YAxis
                yAxisId="right"
                orientation="right"
                stroke="#000"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideRight",
                  offset: 60,
                  fill: "#000",
                }}
              />

              {/* Right Y-Axis (secondary) for PR% */}
              <YAxis
                yAxisId="bottom"
                orientation="right"
                stroke="green"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideRight",
                  offset: 110,
                  fill: "green",
                }}
              />

              <Tooltip />
              <Legend verticalAlign="top" height={36} />

              {/* Bars - use shared right axis */}
              <Bar
                yAxisId="right"
                dataKey="MONTH_Total_KWH"
                fill={LoggedInUserInfo.dash_color}
                name="MONTH_Total_KWH"
              >
                <LabelList dataKey="MONTH_Total_KWH" position="top" style={{ fill: LoggedInUserInfo.dash_color, fontSize: 12, fontWeight: "bold" }} />
              </Bar>

              <Bar
                yAxisId="right"
                dataKey="EXPECTED_KWH"
                fill="#0000ff"
                name="Expected KWH"
              >
                <LabelList dataKey="EXPECTED_KWH" position="top" style={{ fill: "#0000ff", fontSize: 12, fontWeight: "bold" }} />
              </Bar>

              {/* Green Line for PR (%) */}
              <Line
                yAxisId="bottom"
                type="monotone"
                dataKey="MONTH_PR"
                stroke="green"
                name="MONTH_PR"
                strokeWidth={2}
              >
                <LabelList dataKey="MONTH_PR" position="top" style={{ fill: "green", fontSize: 12, fontWeight: "bold" }} />
              </Line>

              {/* Red Line for Cumulative KWH */}
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="Plant_Total_KWH_Cumulative"
                stroke="red"
                name="Plant_Total_KWH_Cumulative"
                strokeWidth={3}
              >
                <LabelList dataKey="Plant_Total_KWH_Cumulative" position="top" style={{ fill: "red", fontSize: 12, fontWeight: "bold" }} />
              </Line>

              <Brush dataKey="MONTH" height={30} stroke="#8884d8" />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default MonthlySumPlant1Curve;



const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "2px",
  borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "3px 6px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  marginLeft: "5px",
  fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};